// Neutral error panel with a way forward (founder ruling 20 Sep §1): a failed fetch is a retry, not
// a broken condition — no red on the container, and never a dead panel. The sentence names what
// failed; Try again re-runs the load.
export const ErrorPanel = ({ message, onRetry, testid }) => (
  <div className="error-panel" data-testid={testid}>
    <span>{message}</span>
    {onRetry && (
      <button className="error-retry" data-testid={(testid || "error") + "-retry"} onClick={onRetry}>
        Try again
      </button>
    )}
  </div>
);
